/* tslint:disable */

declare var Object: any;
export interface KalipsoInterface {
  "id"?: number;
}

export class Kalipso implements KalipsoInterface {
  "id": number;
  constructor(data?: KalipsoInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Kalipso`.
   */
  public static getModelName() {
    return "Kalipso";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Kalipso for dynamic purposes.
  **/
  public static factory(data: KalipsoInterface): Kalipso{
    return new Kalipso(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Kalipso',
      plural: 'kalipsos',
      path: 'kalipsos',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Kalipso.ts